<template>
  <div id="app" class="plc-page">
    <router-view v-if="load === 'success'" class="plc-page__main" />
    <gl-message
        v-else-if="load === 'error'"
        variant="error"
        :message="$t('Config cannot be loaded')"
        style="margin: 20px;"
    />
    <gl-loader v-else is-centered />
  </div>
</template>

<script>
import { EventBus } from '@/event-bus'
import { findUpAttr } from '@/tools'
import { getConfig, getProfile } from '@/plugins/axios'
import GlMessage from '@gl/GlMessage'
import GlLoader from '@gl/GlLoader'

export default {
  name: 'App',
  components: { GlMessage, GlLoader },
  data() {
    return {
      load: 'loading',
    }
  },
  async created() {
    this.$i18n.locale = this.$route.params.locale

    if (this.$route.name === 'home') {
      this.load = 'success'
      return
    }

    if (await this.loadConfig()) {
      if (await this.loadProfile()) {
        this.load = 'success'
      } else {
        await this.$router.push({name: 'home'})
      }
    } else {
      this.load = 'error'
    }
  },
  mounted() {
    const fnDClick = (event) => {
      EventBus.$emit('d-click', findUpAttr(event.target, 'menu-name'))
    }
    document.addEventListener('click', fnDClick, true)
    this.$once('hook:beforeDestroy', () => {
      document.removeEventListener('d-click', fnDClick)
    })
  },
  methods: {
    async loadConfig() {
      const { data } = await getConfig()
      if (data.state === 'success') {
        this.$store.commit('setConfig', data.data)
        return true
      } else {
        return false
      }
    },
    async loadProfile() {
      const inviteCode = this.$route.params.invite;
      const { data } = await getProfile({ inviteCode });
      if (data.state === "success") {
        this.$store.commit('setProfile', data.data)
        return true
      }
      return false;
    },
  }
}
</script>

<style lang="scss">
  @import '~styles/main';
</style>

<style lang="scss" scoped>
  .plc-page {
    background-color: #fff;
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    min-width: 320px;

    &__main {
      display: flex;
      flex-direction: column;
      flex-grow: 1;
    }
  }
</style>
